import { render } from "./DesktopMessagePhotoSelector.vue?vue&type=template&id=6c33dc62&scoped=true&ts=true"
import script from "./DesktopMessagePhotoSelector.vue?vue&type=script&lang=ts"
export * from "./DesktopMessagePhotoSelector.vue?vue&type=script&lang=ts"

import "./DesktopMessagePhotoSelector.vue?vue&type=style&index=0&id=6c33dc62&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c33dc62"]])

export default __exports__